'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

export default function OpenWidgetMessenger() {
  const pathname = usePathname();
  const hasInitialized = useRef(false);

  useEffect(() => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
    const isHome = pathname === '/';
    const isRender = pathname.startsWith('/render/');

    if (typeof window === 'undefined' || isRender) return;

    const initOpenWidget = () => {
      if (hasInitialized.current) return;
      hasInitialized.current = true;

      // Initialize OpenWidget configuration
      window.__ow = window.__ow || {};
      window.__ow.organizationId = process.env.NEXT_PUBLIC_OPENWIDGET_ORG_ID || '7e976ae5-88c5-488e-b9c9-d6a29f2971ed';
      window.__ow.integration_name = "manual_settings";
      window.__ow.product_name = "openwidget";

      // OpenWidget initialization function
      (function(n, t, c) {
        function i(n) {
          return e._h ? e._h.apply(null, n) : e._q.push(n);
        }
        var e = {
          _q: [],
          _h: null,
          _v: "2.0",
          on: function() { i(["on", c.call(arguments)]); },
          once: function() { i(["once", c.call(arguments)]); },
          off: function() { i(["off", c.call(arguments)]); },
          get: function() {
            if (!e._h) throw new Error("[OpenWidget] You can't use getters before load.");
            return i(["get", c.call(arguments)]);
          },
          call: function() { i(["call", c.call(arguments)]); },
          init: function() {
            var n = t.createElement("script");
            n.async = true;
            n.type = "text/javascript";
            n.src = "https://cdn.openwidget.com/openwidget.js";
            t.head.appendChild(n);
          }
        };
        if (!n.__ow.asyncInit && e.init) e.init();
        n.OpenWidget = n.OpenWidget || e;
      })(window, document, [].slice);
    };

    if (isMobile && isHome) {
      const onScroll = () => {
        if (window.scrollY >= window.innerHeight * 0.9) {
          initOpenWidget();
          window.removeEventListener('scroll', onScroll);
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });

      return () => {
        window.removeEventListener('scroll', onScroll);
      };
    } else {
      initOpenWidget();
    }
  }, [pathname]);

  return null;
}